import { render, staticRenderFns } from "./BackBar.vue?vue&type=template&id=5bda8e58&"
import script from "./BackBar.vue?vue&type=script&lang=ts&"
export * from "./BackBar.vue?vue&type=script&lang=ts&"
import style0 from "./BackBar.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports